import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogActions, MatDialogClose, MatDialogContent, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AccionTarea, NuevaTarea } from '../../../../models/Tarea';
import { AvanceComponent } from '../avance/avance.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TareaService } from '../../../../services/tarea.service';
import { ScnackbarData, ToastService, SnackbarStyles } from '../../../../commons/toast.service';

@Component({
    selector: 'app-comentario',
    imports: [
        MatDialogModule, MatDialogActions, MatDialogClose, MatDialogContent,
        MatButtonModule, MatIconModule,
        FormsModule, ReactiveFormsModule, MatFormFieldModule,
        MatInputModule,
        MatProgressSpinnerModule
    ],
    templateUrl: './comentario.component.html',
    styleUrl: './comentario.component.scss'
})
export class ComentarioComponent {
  readonly dialogRef = inject(MatDialogRef<AvanceComponent>);
  readonly data = inject<NuevaTarea>(MAT_DIALOG_DATA);

  nuevaTarea: NuevaTarea

  comentarForm = new FormGroup({
    comentario: new FormControl("", {
      validators: [Validators.required]
    })
  })

  fetchingComentarTarea = false

  snackbarData: ScnackbarData = {}

  constructor(
    private tareaService: TareaService,
    private toast: ToastService
  ) {
    this.nuevaTarea = structuredClone(this.data)
  }

  onSubmitForm() {
    this.fetchingComentarTarea = true
    const formControls = this.comentarForm.controls
    const accionTareas: AccionTarea[] = [
      {
        id: this.nuevaTarea.id,
        idParticipante: this.nuevaTarea.idAsignado,
        comentario: formControls.comentario.value!,
        fechaExpira: this.nuevaTarea.fechaExpira
      }
    ]
    this.tareaService.comentarTarea(accionTareas).subscribe({
      next: (_) => {
        this.snackbarData.message = "Comentario registrado"
        this.snackbarData.style = SnackbarStyles.Success
        this.snackbarData.iconName = "check_circle"
        this.fetchingComentarTarea = false
        this.toast.show(this.snackbarData)
        this.dialogRef.close({ success: true })
      },
      error: (_) => {
        this.snackbarData.message = "Error registrando comentario"
        this.snackbarData.style = SnackbarStyles.Error
        this.snackbarData.iconName = "error"
        this.fetchingComentarTarea = false
        this.toast.show(this.snackbarData)
        this.dialogRef.close({ success: false })
      }
    })
  }

}
